import { registerCustom } from './registerCustom';
registerCustom();
